import api from './api';
import type { ControladorDto, ControladorCreateRequest } from '@/types/controlador';

export const controladoresApi = {
  findAll: () =>
    api.get<ControladorDto[]>('/controladores').then((r) => r.data),

  create: (data: ControladorCreateRequest) =>
    api.post<ControladorDto>('/controladores', data).then((r) => r.data),

  update: (id: number, data: ControladorCreateRequest) =>
    api.put<ControladorDto>(`/controladores/${id}`, data).then((r) => r.data),

  uploadImage: (id: number, formData: FormData) =>
    api.post<ControladorDto>(`/controladores/${id}/imagen`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  delete: (id: number) =>
    api.delete(`/controladores/${id}`),
};
